import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import WhatWeDo from './pages/WhatWeDo';
import WhoWeAre from './pages/WhoWeAre';
import Update from './pages/Update';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import AgroExport from './pages/industries/AgroExport';
import ITSolutions from './pages/industries/ITSolutions';
import Construction from './pages/industries/Construction';
import HomePage from './pages/HomePage';
import Footer from './components/footer/Footer';

// const App: React.FC = () => {
//   return (
//     <>
//       <Navbar />
//       <Routes>
//         <Route path="/" element={<HomePage />} />
//         <Route path="/what-we-do" element={<WhatWeDo />} />
//         <Route path="/who-we-are" element={<WhoWeAre />} />
//         <Route path="/update" element={<Update />} />
//         <Route path="/careers" element={<Careers />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/industries/export" element={<AgroExport />} />
//         <Route path="/industries/it" element={<ITSolutions />} />
//         <Route path="/industries/construction" element={<Construction />} />
//       </Routes>
//     </>
//   );
// };
const App: React.FC = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/what-we-do" element={<div className="page-wrapper"><WhatWeDo /></div>} />
        <Route path="/who-we-are" element={<div className="page-wrapper"><WhoWeAre /></div>} />
        <Route path="/update" element={<div className="page-wrapper"><Update /></div>} />
        <Route path="/careers" element={<div className="page-wrapper"><Careers /></div>} />
        <Route path="/contact" element={<div className="page-wrapper"><Contact /></div>} />
        <Route path="/industries/export" element={<div className="page-wrapper"><AgroExport /></div>} />
        <Route path="/industries/it" element={<div className="page-wrapper"><ITSolutions /></div>} />
        <Route path="/industries/construction" element={<div className="page-wrapper"><Construction /></div>} />
      </Routes>
      <Footer />
    </>
  );
};

export default App;
